var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15H0V30H60V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30H0V45H60V30Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.5C26.6863 28.5 24 25.8137 24 22.5C24 19.1863 26.6863 16.5 30 16.5C33.3137 16.5 36 19.1863 36 22.5C36 25.8137 33.3137 28.5 30 28.5Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27.75C27.1005 27.75 24.75 25.3995 24.75 22.5C24.75 19.6005 27.1005 17.25 30 17.25C32.8995 17.25 35.25 19.6005 35.25 22.5C35.25 25.3995 32.8995 27.75 30 27.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 23.55C29.4199 23.55 28.9498 23.0799 28.9498 22.5C28.9498 21.9201 29.4199 21.45 29.9998 21.45C30.5797 21.45 31.0498 21.9201 31.0498 22.5C31.0498 23.0799 30.5797 23.55 29.9998 23.55Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8301 23.4549C24.6823 23.4744 24.5467 23.3703 24.5272 23.2225C24.5077 23.0746 24.6118 22.939 24.7597 22.9195C24.9075 22.9001 25.0431 23.0041 25.0626 23.152C25.082 23.2998 24.978 23.4354 24.8301 23.4549Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 27.7501L29.8197 24.6001L29.9997 23.1001L30.1797 24.6001L29.9997 27.7501Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIndia);
export default __webpack_public_path__ + "static/media/in India.d81b64cef796ed6ce8c12c23943ebc5f.svg";
export { ForwardRef as ReactComponent };